<template>
  <div class="account-favorites">
    <div class="account-favorites__title">
      <h2>Избранное</h2>
    </div>

    <transition
      name="fade"
      mode="out-in"
    >
      <ui-loader
        v-if="isLoading"
        key="loader"
        size="60"
        class="account-favorites__loader"
      />

      <div v-else>
        <favorite-gallery
          v-if="hasFavorites"
          :products="products"
          :is-end="isEnd"
          :is-loading="isLoadingProducts"
          @load="loadFavoritesProducts"
        />
        <page-info
          v-else
          title="Список избранных товаров пуст"
          subtitle="Добавьте товары в список избранных, чтобы было проще оформить следующий заказ"
        >
          <ui-button
            ref="startBuyBtn"
            text="Начать покупки"
            @click="startBuy"
          />
        </page-info>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PageInfo from '@/components/common/page-info.vue';
import FavoriteGallery from '@/components/favorite-gallery/favorite-gallery.vue';

export default {
  name: 'account-favorites',

  components: {
    PageInfo,
    FavoriteGallery,
  },

  data: () => ({
    limit: 100,
    isLoading: false,
  }),

  computed: {
    ...mapGetters({
      hasFavorites: 'favorites/hasFavorites',
    }),
    ...mapState({
      products: state => state.favorites.favorites,
      isLoadingProducts: state => state.favorites.favoritesMeta.isLoading,
      isEnd: state => state.favorites.favoritesMeta.isEnd,
      isPrefetched: state => state.favorites.favoritesMeta.isPrefetched,
      offset: state => state.favorites.favoritesMeta.offset,
    }),
  },

  serverPrefetch() {
    return this.loadFavoritesProducts();
  },

  created() {
    if (this.$isServer || this.isPrefetched) return;
    this.isLoading = true;
    this.loadFavoritesProducts().finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    ...mapActions('favorites', ['loadFavorites']),

    startBuy() {
      location.assign('/');
    },

    loadFavoritesProducts() {
      const offset = this.limit + this.offset;
      return this.loadFavorites({ offset, isServer: this.$isServer });
    },
  },
};
</script>

<style lang="scss">
.account-favorites {
  padding-top: 32px;

  @include breakpoint("desktop") {
    margin-right: 156px;
    padding-top: 0;
  }

  &__title {
    margin-bottom: 24px;

    @include breakpoint("desktop") {
      margin-bottom: 31px;
    }
  }

  &__loader {
    color: $blue;
    margin: auto;
  }
}
</style>
